import { AfterViewInit, ChangeDetectorRef, Component, inject, ViewChild } from '@angular/core';
import { TableComponent } from '../../../components/table/table.component';
import { MatExpansionPanel } from '@angular/material/expansion';
import { AlertaService } from '../../../services/alerta.service';
import { Router } from '@angular/router';
import { tableModel } from '../../../components/table/model/tableModel';
import { CostsPerEmployeeGroupService } from '../../../services/cost-per-employee-group.service';
import { FilterCostsPerEmployeeGroup } from '../../../models/filters/filter-cost-per-employees-group';

@Component({
  selector: 'app-cost-per-employees',
  standalone: false,
  templateUrl: './cost-per-employees.component.html',
  styleUrl: './cost-per-employees.component.css'
})
export class CostPerEmployeesComponent implements AfterViewInit {

  ngAfterViewInit(): void {
    throw new Error('Method not implemented.');
  }

  @ViewChild(TableComponent) costsPerEmployeesTable:TableComponent| undefined;
  @ViewChild('advancedPanel') advancedPanel!: MatExpansionPanel;

  tableModel: tableModel= {
    columnModel:[
      {columnName:'#',columnValue:'id'},
      {columnName:'Descripción',columnValue:'description'}
    ],
    dataSource:[],
    editButton:true
  };

  pageIndex: number = 1;
  pageSize: number = 5;
  loading: boolean = false;
  filterCostsPerEmployeeGroup: FilterCostsPerEmployeeGroup = new FilterCostsPerEmployeeGroup;
  advancedSearch: boolean = false;
  
  private costsPerEmployeeGroupService = inject(CostsPerEmployeeGroupService);
  router = inject(Router);
  private cdr = inject(ChangeDetectorRef);
  private alerta = inject(AlertaService);

  ngOnInit(): void {
    this.filterCostsPerEmployeeGroup = new FilterCostsPerEmployeeGroup();
    this.searchCostsPerEmployeeGroupPaginator();
  }
  paginatorEvent(event: any){
    this.pageIndex = (event.pageIndex+1);
    this.pageSize = event.pageSize;
    this.searchCostsPerEmployeeGroupPaginator();
  }

  editEvent(event: any){
    this.router.navigate(['/costsPerEmployeeGroup/edit', event.id]);
  }
  addNewCostsPerEmployeeGroup(){
    this.router.navigate(['/costsPerEmployeeGroup/edit', 0]);
  }

  searchCostsPerEmployeeGroupPaginatorAS(){
    this.pageIndex = 1;
    this.advancedSearch = true;
    this.searchCostsPerEmployeeGroupPaginator();
  }

  searchCostsPerEmployeeGroupPaginator(){
    this.loading = true;

    this.costsPerEmployeeGroupService.findAllPageableCostsPerEmployeeGroup(this.filterCostsPerEmployeeGroup, this.pageIndex, this.pageSize).subscribe({
      next: (pageable) => {
        this.tableModel.pageSize = pageable.pageSize;
        this.tableModel.totalRecords = pageable.itemsCount;
        this.tableModel.dataSource = pageable.list;
        this.tableModel.pageNumber = pageable.pageNum;
        
        setTimeout(() => {
          this.costsPerEmployeesTable?.refresh(pageable.list, pageable.itemsCount);
        });
        this.loading = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.loading = false;
        if(err.status == 400){
          this.alerta.error("Se ha terminado el tiempo de session: ", {detail: err.message});
          this.router.navigate(['/login']);
        }else{
          this.alerta.error("Se ha precentado un error interno: ", {detail: err.message});
        }
      }
    });

    if(this.advancedPanel != null){
      if (this.advancedSearch) {
        this.advancedPanel.open();
      } else {
        this.advancedPanel.close();
      }
    }
  }
}
